<div class="col-md-12 clear-all top-nav flex-container ">
  <div class="col-md-6 h-100 nav-right pl-20  ">

    @if (visibleBackNav) {
      <span tabindex="0" id="top-nav-cta-left" name="top-nav-cta-left" (click)="goBack()"
        class="dls-button dls-prev-btn reflect " [ngClass]="{'disable-control':!enableBackNav}" (keyup.enter)="goBack()">
        <i class="icon icon-chevron-left"></i>
        <a class="nav-btn ml-15 mr-0 font-weight" [ngClass]="{'pointer':enableBackNav}" id="back-text" aria-label="back">
          {{router.url === '/apply/clear-to-apply' ? contentData.contentTopNavigationBar.backToYourQuotes :
        contentData.contentTopNavigationBar.back}}</a>
      </span>
    }

  </div>
  @if (visibleSaveProgress) {
    <div class="col-md-6 text-right nav-right h-100 pr-22 ">
      @if (enableQuote && !abc) {
        <a id="top-nav-cta-right" tabindex="0" name="top-nav-cta-right"
          class="nav-btn pointer reflect" (click)="retriveQuote()" (keyup.enter)="retriveQuote()">
          <u>{{contentData.contentTopNavigationBar.retrieveQuote}}</u>
        </a>
      }
      @if (closeBtnEnabled) {
        <strong tabindex="0" id="top-nav-cta-right" name="top-nav-cta-right"
          class="nav-btn pointer reflect" (click)="close()"
        (keyup.enter)="close()">{{contentData.contentTopNavigationBar.close}}</strong>
      }
      <span>
        @if (!enableQuote && !abc && !closeBtnEnabled
          && router.url !== '/home/get-your-online-quote' && router.url !== '/apply/your-product-application' && router.url !== '/home/update-my-details' && router.url !== '/home/guidance-and-advice') {
          <app-save #savecomp [emitInvalidEvtFlag]="emitInvalidEvtFlag" [cdRefParent]="cdRefParent"
            [parentFormToJustToClear]="parentFormToJustToClear" [parentElement]="parentElement"
            [parentFormToValidate]="parentFormToValidate" [saverAndReturnObj]="saverAndReturnObj" (closeSaveModal)="close()"
            [location]="'contentTop'"
          ></app-save>
        }
      </span>
    </div>
  }
</div>
@if (isLocked) {
  <app-modal [modalConfig]="lockedAlertModalConfig" (closeModal)="closeLockedModal()"
    (primaryBtnClick)="closeLockedModal()" [saveDataFlag]="false">
  </app-modal>
}